import React from "react";

import { MdKeyboardArrowDown } from "react-icons/md";
import { NavLink as Link } from "react-router-dom";
import Featuredproducts from "./Tabs/Products/Featuredproducts";
import IntelligentApps from "./Tabs/Products/IntelligentApps";
import { Learn1, Learn2, Learn3 } from "./data";
import "./Menu.scss";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import ControlSystems from "./Tabs/Products/ControlSystems";
import Business from "./Tabs/Products/Business";
import Media from "./Tabs/Products/Media";
import Language from "./Tabs/Products/Language";
import MachineLearning from "./Tabs/Products/MachineLearning";
import IndustrySolutions from "./Tabs/Solutions/IndustrySolutions";
import UseCase from "./Tabs/Solutions/UseCase";
import AiEarth from "./Tabs/Solutions/AiEarth";
import Research from "./Tabs/Solutions/Research";

function Menu() {
  return (
    <ul className="nav__menu nav-menu" id="navlist">
      <li className="nav__list list" id="link1">
        <Link
          to="/products"
          className="nav__anchor link"
          activeClassName="nav__activeLink"
        >
          Products
          <MdKeyboardArrowDown className="nav__list--d-arrow" />
        </Link>
        <div className="submenu submenu1">
          <div className="Products__tabs">
            <Tabs>
              <TabList>
                <Tab>Featured Products</Tab>
                <Tab>Intelligent Apps</Tab>
                <Tab>Control Systems</Tab>
                <Tab>Business</Tab>
                <Tab>Media</Tab>
                <Tab>Language AI</Tab>
                <Tab>Machine Learning Services</Tab>
              </TabList>
              <TabPanel>
                <Featuredproducts />
              </TabPanel>
              <TabPanel>
                <IntelligentApps />
              </TabPanel>
              <TabPanel>
                <ControlSystems />
              </TabPanel>
              <TabPanel>
                <Business />
              </TabPanel>
              <TabPanel>
                <Media />
              </TabPanel>
              <TabPanel>
                <Language />
              </TabPanel>
              <TabPanel>
                <MachineLearning />
              </TabPanel>
            </Tabs>
          </div>
          <div></div>
        </div>
      </li>
      <li className="nav__list list" id="link2">
        <Link
          to="/solutions"
          className="nav__anchor link"
          activeClassName="nav__activeLink"
        >
          Solutions
          <MdKeyboardArrowDown className="nav__list--d-arrow" />
        </Link>
        <div className="submenu submenu2">
          <div className="Solutions__tabs">
            <Tabs>
              <TabList>
                <Tab>Industry Solutions</Tab>
                <Tab>Use Case Solutions</Tab>
                <Tab>HostAI Earth</Tab>
                <Tab>Research</Tab>
              </TabList>
              <TabPanel>
                <IndustrySolutions />
              </TabPanel>
              <TabPanel>
                <UseCase />
              </TabPanel>
              <TabPanel>
                <AiEarth />
              </TabPanel>
              <TabPanel>
                <Research />
              </TabPanel>
            </Tabs>
          </div>
          <div></div>
        </div>
      </li>
      <li className="nav__list list">
        <Link
          to="/companies"
          className="nav__anchor link single-link"
          activeClassName="nav__activeLink"
        >
          Companies
        </Link>
      </li>
      <li className="nav__list">
        <Link
          to="/pricing"
          className="nav__anchor link single-link"
          activeClassName="nav__activeLink"
        >
          Pricing
        </Link>
      </li>
      <li className="nav__list">
        <Link
          to="/developers"
          className="nav__anchor link single-link"
          activeClassName="nav__activeLink"
        >
          Developers
        </Link>
      </li>
      <li className="nav__list">
        <Link
          to="/support"
          className="nav__anchor link single-link"
          activeClassName="nav__activeLink"
          id="support"
        >
          Support
        </Link>
      </li>
      <li className="nav__list list" id="link3">
        <Link
          to="/learn"
          className="nav__anchor link"
          activeClassName="nav__activeLink"
          id="learn"
        >
          Learn
          <MdKeyboardArrowDown className="nav__list--d-arrow" />
          <div className="submenu submenu3">
            <ul>
              {Learn1.map((list) => {
                return (
                  <Link to={list.path}>
                    <li>
                      <div className="circle">
                        <div className="sub-icon">{list.icon}</div>
                      </div>
                      <div className="content">
                        <h5>{list.title}</h5>
                      </div>
                    </li>
                  </Link>
                );
              })}
            </ul>
            <ul className="submenu3-list">
              {Learn2.map((list) => {
                return (
                  <Link to={list.path}>
                    <li>
                      <div className="circle">
                        <div className="sub-icon">{list.icon}</div>
                      </div>
                      <div className="content">
                        <h5>{list.title}</h5>
                        <p>{list.desc}</p>
                      </div>
                    </li>
                  </Link>
                );
              })}
            </ul>
            <ul className="submenu3-list2">
              {Learn3.map((list) => {
                return (
                  <Link to={list.path}>
                    <li>
                      <div className="circle">
                        <div className="sub-icon">{list.icon}</div>
                      </div>
                      <div className="content">
                        <h5>{list.title}</h5>
                        <p>{list.desc}</p>
                      </div>
                    </li>
                  </Link>
                );
              })}
            </ul>
            <div className="other-part">
              <h2>Join our community</h2>
              <p>
                Find expert advice, informal chats, live event feeds, launch
                news, and community stories here.
              </p>
              <button>Join Now</button>
            </div>
          </div>
        </Link>
      </li>
    </ul>
  );
}

export default Menu;
